import React from 'react';
import { IIconProps } from '../interfaces';

const AleaCalendarIcon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '26',
}) => {
  const width = parseInt(String(size), 10);
  const height = (30 / 26) * width;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 26 30" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Frame 615">
        <rect 
          id="Rectangle 125" 
          x="1.58594" 
          y="5.45898" 
          width="22.5601" 
          height="22.5601" 
          rx="4.51201" 
          fill="white" 
          stroke={color} 
          strokeWidth="2"
        />
        <path 
          id="Rectangle 126" 
          d="M1.58594 9.971C1.58594 7.47908 3.60603 5.45898 6.09795 5.45898H19.634C22.1259 5.45898 24.146 7.47908 24.146 9.971V12.7452H1.58594V9.971Z" 
          fill={color} 
          stroke={color} 
          strokeWidth="2"
        />
        <rect 
          id="Rectangle 127" 
          x="17.668" 
          y="16.7188" 
          width="2.70721" 
          height="2.70721" 
          fill={color} 
          stroke={color} 
          strokeWidth="2"
        />
        <g id="Group 188">
          <path 
            id="Line 155" 
            d="M7.38281 6.09375L7.38281 1.98006" 
            stroke={color} 
            strokeWidth="2" 
            strokeLinecap="round"
          />
          <path 
            id="Line 156" 
            d="M18.3516 6.09375L18.3516 1.98006" 
            stroke={color} 
            strokeWidth="2" 
            strokeLinecap="round"
          />
        </g>
      </g>
    </svg>
  );
};

export default AleaCalendarIcon; 